// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2woxB","title":"ClientInsurance_title__29FJB","itemText":"ClientInsurance_itemText__JrrHe"};